<template>
  <div class="childComments">
    <comment v-for="(comment, index) in sortedComments" :comment="comment" :key="index" :childComments="childComments" :postId="postId"></comment>
  </div>
</template>

<script>
  import Comment from './Comment'

  export default {
    name: 'child-comments',
    props: ['comments', 'childComments', 'postId'],
    components: {
      Comment
    },
    computed: {
      sortedComments () {
        return this.comments.reverse()
      }
    }
  }
</script>




// WEBPACK FOOTER //
// ChildComments.vue?6e17bf5c